export default __webpack_public_path__ + "static/media/84f4c3f624865721c881f61f7e1d2ac4.svg";